/**
 * Stunden:Minuten = 1; dezimal(Industrieminuten) = 2, db-format(HHHHmmss)=99
 */
import $ from 'jquery';
import _ from 'lodash';
import Property from 'collection/PropertyCollection';
import {getSisDurationAsISO, getSisDurationAsNumber, parseSisDuration} from 'util/SisDateTime';
import {padStr} from 'util/StringUtil';
import {PropID} from 'module/Properties/enum/PropID';

var defaultDurFormat = 1;
var durFormatFromServer = defaultDurFormat;
//////////////////////////////////////////////////////////////////////
// DO NOT use these for match (use g flag for match, js regex bug) //
////////////////////////////////////////////////////////////////////
// minus optional, 0-4 stellige stunden, divider, 0-2 stellige minuten
var durationUserInputRegExp = /(^-?[0-9]{0,4}([.:][0-9]{0,2})?$)/;
// ++++else
var specialPlusRegExp = /^\+\+[\.:]?\+\+$/;
// ----
var specialMinusRegExp = /^--[\.:]?--$/;

var dbFormatRegExp = /-?[0-9]{0,8}/;

/**
 * @param value {*}
 * @param [durationFormat] {Integer} durationFormat, other than iProperty
 * @returns {boolean}
 */
function validateDurationUserInput(value, durationFormat) {
	durationFormat = durationFormat || durFormatFromServer;
	if (specialPlusRegExp.test(value) || specialMinusRegExp.test(value)) return true;
	var seconds;
	var minutes;
	var hours;
	switch (durationFormat) {
		case 99:
			if (!dbFormatRegExp.test("" + value)) return false;
			var abs = Math.abs(parseInt(value));
			seconds = abs % 100;
			minutes = Math.floor(abs / 100) % 100;
			hours = Math.floor(abs / 10000);
			return (0 <= seconds && seconds <= 59) && (0 <= minutes && minutes <= 59) && (0 <= hours && hours <= 9999);
		case 1:
		case 2:
			value += "";
			var validRegex = durationUserInputRegExp.test(value);
			if (!validRegex) return false;
			var divider = getDurationDivider(durationFormat);
			var maxMinutes = getDurationMaxMinutes(durationFormat);
			var maxHours = 9999;
			var valueParts = value.split(divider);
			hours = Math.abs(parseInt(valueParts[0]) || 0);
			minutes = parseInt(valueParts[1]) || 0;
			var validMinutes = (0 <= minutes && minutes <= maxMinutes);
			var validHours = (0 <= hours && hours <= maxHours);
			return validRegex && validMinutes && validHours;
		default:
			console.error('Wrong DurFormat:' + durationFormat);
			return false;
	}
}

function adaptDivider(value, durationFormat) {
	//allowed dividers: /,.: => replace with correct divider
	return (value + '').replace(/[\/,\.:]/g, getDurationDivider(durationFormat));
}

/**
 * derived from formutil validate_duration
 * takes userinput and forms a valid string input from it.
 * validate before calling!
 * @param value {string}
 * @param [durationFormat] {Integer} durationFormat, other than iProperty
 * @returns {String} resulting, valid value with correct divider, ready for parsing
 */
function adaptValidatedDuration(value, durationFormat) {
	durationFormat = durationFormat || durFormatFromServer;
	value += "";

	var divider = getDurationDivider(durationFormat);

	var retVal = value + "";

	retVal = retVal.trim();

	//special char ++++
	if (retVal.indexOf("++") >= 0) {
		return "++" + divider + "++";
	}
	//special char ----
	if (retVal.indexOf("--") >= 0) {
		return "--" + divider + "--";
	}

	// save sign, added before return

	//durformat 99 finished
	if (durationFormat == 99) return retVal;
	// continue adapting durationFormat 1,2

	var neg = false;
	if (retVal.indexOf('-') >= 0) {
		neg = true;
		retVal = retVal.replace(/-/g, '');
	}
	var duration_pieces = retVal.split(divider);
	var help_hours = parseInt(duration_pieces[0]) ? duration_pieces[0] : 0;
	var help_minutes = parseInt(duration_pieces[1]) ? duration_pieces[1] : 0;
	//add zero (format 1:left) (format 2:right)
	switch (durationFormat) {
		case 1:
			help_minutes = padStr(help_minutes, 2, "0", false);
			break;
		case 2:
			help_minutes = padStr(help_minutes, 2, "0", true);
			break;
		default:
			break;
	}

	// sign remailns in hours
	retVal = (neg ? "-" : "") + help_hours + divider + help_minutes;
	return retVal;
}

/**
 * from SisFieldFormat#displayFormatDuration2
 * @param momentDuration {Moment.duration}
 * @returns {String}
 */
function toViewFormat2EPZE(momentDuration) {
	var x = getSisDurationAsNumber(momentDuration);
	var h; //int
	var m; //int
	var s; //int
	var neg;
	neg = x < 0;
	x = Math.abs(x);
	h = Math.floor(x / 10000);
	x -= h * 10000;
	m = Math.floor(x / 100);
	s = x - m * 100;
	var d = h + m / 60 + s / 3600;
	var ret = Math.round(d * 100) / 100;
	//ret += "";
	//if (ret.indexOf(".") == ret.length - 2) ret = ret + "0";
	ret = ret.toFixed(2);
	return (neg ? "-" : "") + ret;
}

/**
 * blackboxing method from epze formutil to have same functionality
 * @param val
 * @param [durationFormat] {Integer} durationFormat, other than iProperty
 * @returns {*}
 */
function toModelEPZE(val, durationFormat) {
	durationFormat = durationFormat || durFormatFromServer;
	var value = (val + "").trim();
	if (specialPlusRegExp.test(value)) return 99990000;
	if (specialMinusRegExp.test(value)) return -99990000;

	//epze code
	var dec_hours;
	var dec_minutes;
	switch (durationFormat) {
		case 1:
			value = value.replace(/:/g, '');
			value = value + "00";
			break;
		case 2:
			// epze defined exactly this conversion! do not change without proper testing
			// -> rounding errors are intended
			var floatValue = parseFloat(value);
			var neg = floatValue < 0;
			floatValue = Math.abs(floatValue);
			dec_hours = Math.floor(floatValue);
			dec_minutes = parseInt(value.split('.')[1]) || 0;
			var dur_hours = dec_hours;
			var dur_minutes = 0;
			var dur_seconds = 0;
			var seconds = (parseFloat(dec_minutes) / 100) * 3600;
			dur_minutes = Math.round(seconds / 60);
			dur_seconds = Math.round(seconds - dur_minutes * 60);
			if (dur_seconds < 0) dur_seconds = 0;
			value = (neg ? "-" : "") + dur_hours + padStr(dur_minutes, 2, '0') + padStr(dur_seconds, 2, '0');
			break;
		case 99:
			break;
		default:
			console.error('Wrong DurFormat:' + durationFormat);
			break;
	} // switch
	//end epze

	value = parseInt(value);
	return value;
}

function getDurationDivider(durformat) {
	switch (durformat) {
		case 2:
			return ".";
			break;
		case 99:
			return "";
			break;
		case 1:
		default:
			return ":";
			break;
	}
}

function getDurationMaxMinutes(durformat) {
	switch (durformat) {
		case 2:
			return 99;
			break;
		case 1:
		case 99:
		default:
			return 59;
			break;
	}
}

///////////////////////////////////////////////////

function _toView(value, durationFormat) {
	durationFormat = durationFormat || durFormatFromServer;
	var divider = getDurationDivider(durationFormat);
	var ret;
	if (value == 99990000) {
		ret = "++" + divider + "++";
	} else if (value == -99990000) {
		ret = "--" + divider + "--";
	} else {
		var momentDur = parseSisDuration(value);
		switch (durationFormat) {
			case 1:
				// default Format = 1, HH:mm
				ret = getSisDurationAsISO(momentDur);
				break;
			case 2:
				// format = 2, decimal format
				ret = toViewFormat2EPZE(momentDur);
				break;
			case 99:
				ret = getSisDurationAsNumber(momentDur);
		}
	}
	return ret;
}

/**
 * not stable atm.
 * use SisDuration.toModel
 * @param value
 * @param durationFormat
 * @returns {*}
 * @private
 */
function _toModel(value, durationFormat) {
	durationFormat = durationFormat || durFormatFromServer;
	//use correct divider
	value = adaptDivider(value, durationFormat);
	//validate adapted
	if (!validateDurationUserInput(value, durationFormat)) return null;
	//replace value when allowed input
	value = adaptValidatedDuration(value, durationFormat);
	//convert value to calculated db-value
	value = toModelEPZE(value, durationFormat);
	return value;
}

//additional conversion on server (SisDuration#get(1))
function adaptRoundingError(value) {
	var durationInSeconds = Math.floor(value / 10000) * 3600 + Math.floor(Math.floor(value - Math.floor(value / 10000) * 10000) / 100) * 60 + Math.floor(value - Math.floor(value / 100) * 100);

	var hours = Math.floor(durationInSeconds / 3600);
	var minutes = Math.floor(Math.floor(durationInSeconds - Math.floor(durationInSeconds / 3600) * 3600) / 60);
	var seconds = Math.floor(durationInSeconds - hours * 3600 - minutes * 60);
	return hours * 10000 + minutes * 100 + seconds
}

///////////////
/// public ///
/////////////

/**
 *
 * @param value
 * @param [durationFormat] {Integer} durationFormat, other than iProperty
 * @returns {*}
 */
function toView(value, durationFormat) {
	return _toView(value, durationFormat);
}

/**
 * @param value
 * @param [durationFormat] {Integer} durationFormat, other than iProperty
 * @returns {Integer} adapted, correct value or null if invalid.
 */
function toModel(value, durationFormat) {
	//return _toModel(value, durationFormat); //ignores second rounding action -> not stable
	return _toModel(_toView(_toModel(value, durationFormat), durationFormat), durationFormat);
}

export default {
	/**
	 * call this method to initialize
	 * @returns {*}
	 */
	fetchProperties: function () {
		return $.when(Property.get(PropID.evoApps_durFormat)).done(function (data) {
			durFormatFromServer = parseInt(data) || defaultDurFormat;
			if (!_.includes([1, 2, 99], durFormatFromServer)) {
				console.error('Wrong DurFormat' + durFormatFromServer);
				durFormatFromServer = defaultDurFormat;
			}
		});
	},
	durFormat: durFormatFromServer,
	toView: toView,
	toModel: toModel,
};